import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "./Ascreen.css";
import sample from "../sample.png";
import jira from "../atlassian.png";
import right from "../right.png";
import left from "../left.png";
import MyChart from "./MyChart";
import SimplePieChart from "../SimplePieChart";
import SimpleBarChart from "./SimpleBarChart";
import Line from "../line.png";
import Pie from "../pie-chart.png";
import Table from "../table.png";
import Bar from "../bar-chart.png";
import Reset from "../reset.png";
import Next from "../next.png";
import axios from "axios";
import { CardContext } from "../utils/Context/cardContext";
const Ascreen = () => {
  const {appStat} = useContext(CardContext)
  const [Showline, SetShowline] = useState(true);
  const [ShowPie, SetShowpie] = useState(true);
  const [ShowBar, SetShowbar] = useState(true);
  const [ShowChoose, SetShowchoose] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [selectedOption,setSelectedOption] = useState('')
  const [statsData,setStatsData] = useState(appStat['30_days'])
  const handleButtonClick = () => {
    SetShowline(true);
    SetShowpie(true);
    SetShowbar(true);
    SetShowchoose(true);
  };
  console.log(appStat)

  const handleOptionChange = (e) =>{
  
    setSelectedOption(e.target.value)
   
  }
    useEffect(()=>{
      if(selectedOption == "60"){
        setStatsData(appStat['60_days'])
      }else {
        setStatsData(appStat['30_days'])
      }
    },[selectedOption])
   
  return (
    <div className="mmain">
      <div className="sbar">
        <img src={jira} className="logo1" />
      </div>
      <div className="mains">
        <div className="controls1">
          <div className="form-group">
            <select id="dropdown" values={selectedOption} onChange={handleOptionChange}>
              <option value="">Last Accessed</option>
              <option value="30">30 days</option>
              <option value="60">60 days</option>
              <option value="option3">180 days</option>
            </select>
          </div>
          <div className="form-group">
            <select id="dropdown">
              <option value="">User Status</option>
              <option value="option1">30 days</option>
              <option value="option2">60 days</option>
              <option value="option3">180 days</option>
            </select>
          </div>
          <button className="button-28">
            <img src={Next} className="ricon" />
          </button>
        </div>
        <div className="controls2">
          {Showline && <MyChart statsData = {statsData} />}
          {ShowPie && <SimplePieChart statsData = {statsData} />}
          {ShowBar && <SimpleBarChart statsData = {statsData} />}
          {ShowChoose && (
            <div className="choose">
              <button className="cbtn">
                <img
                  src={Reset}
                  alt=""
                  className="cimgg"
                  onClick={handleButtonClick}
                />
              </button>
              <button className="cbtn">
                <img
                  src={Line}
                  alt=""
                  className="cimgg"
                  onClick={() => {
                    SetShowpie(false);
                    SetShowbar(false);
                    SetShowchoose(true);
                    setIsButtonDisabled(false);
                  }}
                />
              </button>
              <button className="cbtn">
                <img
                  src={Bar}
                  alt=""
                  className="cimgg"
                  onClick={() => {
                    SetShowpie(false);
                    SetShowline(false);
                    SetShowchoose(true);
                  }}
                />
              </button>
              <button className="cbtn">
                <img
                  src={Pie}
                  alt=""
                  className="cimgg"
                  onClick={() => {
                    SetShowbar(false);
                    SetShowline(false);
                    SetShowchoose(true);
                  }}
                />
              </button>
              <button className="cbtn">
                <img src={Table} alt="" className="cimgg" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Ascreen;
